<template>
  <div>
    <v-btn @click="dialog = true" rounded color="">Transactions</v-btn>
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <h2>Select Transaction</h2>
          <br />
          <div class="d-flex">
            <v-btn
              :color="
                this.selectedTransaction == 'transferFunds' ? 'primary' : 'gray'
              "
              depressed
              class="mr-2"
              @click="selectTransaction('transferFunds')"
              >Transfer Funds</v-btn
            >
            <v-btn
              :color="
                this.selectedTransaction == 'purchaseMerchandise'
                  ? 'primary'
                  : 'gray'
              "
              depressed
              class="mr-2"
              @click="selectTransaction('purchaseMerchandise')"
              >Purchase Merchandise</v-btn
            >
            <v-btn
              :color="
                this.selectedTransaction == 'bankTransactionFee'
                  ? 'primary'
                  : 'gray'
              "
              depressed
              class="mr-2"
              @click="selectTransaction('bankTransactionFee')"
              >Bank Transaction Fee</v-btn
            >
          </div>
          <div class="d-flex mt-2">
            <v-btn
              :color="
                this.selectedTransaction == 'receivedRmaItems'
                  ? 'primary'
                  : 'gray'
              "
              depressed
              class="mr-2"
              @click="selectTransaction('receivedRmaItems')"
              >Received RMA Items</v-btn
            >
            <v-btn
              :color="
                this.selectedTransaction == 'payExpenses' ? 'primary' : 'gray'
              "
              depressed
              class="mr-2"
              @click="selectTransaction('payExpenses')"
              >Pay Expenses</v-btn
            >
            <v-btn
              :color="
                this.selectedTransaction == 'setPayables' ? 'primary' : 'gray'
              "
              depressed
              class="mr-2"
              @click="selectTransaction('setPayables')"
              >Set Payables</v-btn
            >
          </div>

          <h3 class="mt-5 mb-5">Involved Accounts</h3>
          <div class="d-flex">
            <v-select
              :label="drLabel"
              :items="chart_of_accounts"
              item-text="account_title"
              item-value="id"
              v-model="form.debitChartOfAccountId"
              class="mr-2"
            ></v-select>

            <v-select
              :label="crLabel"
              :items="chart_of_accounts"
              item-text="account_title"
              item-value="id"
              v-model="form.creditChartOfAccountId"
            ></v-select>
          </div>
          <div class="d-flex">
            <v-text-field
              type="number"
              label="Amount"
              class="mr-2"
              prepend-inner-icon="mdi-cash"
              v-model="form.amount"
            ></v-text-field>
            <v-text-field
              label="Remarks/Purpose"
              v-model="form.remarks"
              prepend-inner-icon="mdi-pen"
            ></v-text-field>
            <p class="mt-6 mr-2 ml-2">Journal Date</p>
            <input type="date" v-model="form.date" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">transactionsModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex/dist/vuex.common.js";
import axios from "axios";
import moment from "moment";
export default {
  props: ["item"],
  data() {
    return {
      selectedTransaction: "transferFunds",
      dialog: false,
      loading: false,
      //Chart of Account IDs
      merchandiseInventoryId: 7,
      cashOnHandId: 5,
      pettyCashId: 70,
      gcashId: 9,
      itemsForReplaceId: 60,
      bankTransactionFeeId: 42,
      rcbcHexaId: 49,
      creditCard: 76,

      drLabel: "To Source Account(DR)",
      crLabel: "From Destination Account(CR)",

      form: {
        debitChartOfAccountId: 70,
        creditChartOfAccountId: 5,
        remarks: "",
        amount: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
  mounted() {
    this.form.date = moment().format("Y-MM-DD");
  },
  methods: {
    ...mapActions({
      get_journal_entries: "journal_entry/get_journal_entries",
    }),
    async submit() {
      //check if empty
      if (this.form.remarks == "" || this.form.amount == "")
        return alert("All fields are required");
      if (window.confirm("Are you sure you want to submit?")) {
        await axios.post("/postTransactions", this.form).catch((e) => {
          return alert(e.message);
        });
        //refresh journal entries
        this.get_journal_entries();
        alert("Successfully recorded a transaction");
      }
    },
    selectTransaction(trans) {
      this.selectedTransaction = trans;
      //set chart of accounts
      this.setChartOfAccounts(trans);
      //change dr and cr labels
      this.setLabels(trans);
      //reset fields
      this.resetFields();
      //if bank transaction fee, do set default remarks to Bank Fee
      this.checkIfBankFee(trans);
    },
    checkIfBankFee(trans) {
      if (trans == "bankTransactionFee")
        this.form.remarks = "Bank Transaction Fee";
    },
    setChartOfAccounts(trans) {
      if (trans == "transferFunds") {
        this.form.debitChartOfAccountId = this.pettyCashId;
        this.form.creditChartOfAccountId = this.cashOnHandId;
      } else if (trans == "purchaseMerchandise") {
        this.form.debitChartOfAccountId = this.merchandiseInventoryId;
      } else if (trans == "bankTransactionFee") {
        this.form.debitChartOfAccountId = this.bankTransactionFeeId;
        this.form.creditChartOfAccountId = this.rcbcHexaId;
      } else if (trans == "setPayables") {
        this.form.creditChartOfAccountId = this.creditCard;
        this.form.debitChartOfAccountId = this.merchandiseInventoryId;
      } else if (trans == "payExpenses") {
        this.form.creditChartOfAccountId = this.pettyCashId;
        this.form.debitChartOfAccountId = this.merchandiseInventoryId;
      }
    },
    resetFields() {
      this.form.amount = "";
      this.form.remarks = "";
    },
    setLabels(trans) {
      if (trans == "transferFunds") {
        this.drLabel = "To Source Account(DR)";
        this.crLabel = "From Destination Account(CR)";
      } else if (trans == "purchaseMerchandise") {
        this.drLabel = "Item Account";
        this.crLabel = "Payment Method";
      } else if (trans == "bankTransactionFee") {
        this.drLabel = "Expense";
        this.crLabel = "Payment Method";
      } else if (trans == "payExpenses") {
        this.drLabel = "Expense Type";
        this.crLabel = "Payment Method";
      } else if (trans == "setPayables") {
        this.drLabel = "Asset";
        this.crLabel = "Payment Method";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
